// PowerSync — essay_submissions (+ overall_score из grading_results для списка).
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalEssaySubmission {
	id: string;
	user_id: string;
	title: string;
	word_count: number | null;
	language: string | null;
	status: string;
	grading_result_id: string | null;
	graded_at: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	error_message: string | null;
}

export interface LocalEssayListRow extends LocalEssaySubmission {
	/** overall_score из grading_results (LEFT JOIN), может быть null. */
	overall_score: number | null;
}

export function useEssaySubmissionsQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalEssayListRow>(
		`SELECT e.*, g.overall_score AS overall_score
		   FROM essay_submissions e
		   LEFT JOIN grading_results g ON g.id = e.grading_result_id
		  WHERE e.user_id = ? AND e.deleted_at IS NULL
		ORDER BY e.updated_at DESC`,
		[userId ?? ""],
	);
}

export function useEssaySubmissionByIdQuery(essayId: string | undefined) {
	return usePowerSyncQuery<LocalEssaySubmission>(
		`SELECT * FROM essay_submissions
		   WHERE id = ? AND deleted_at IS NULL`,
		[essayId ?? ""],
	);
}
